import React from "react";
import _ from "lodash";
import cx from "classnames";
import { useTranslation } from "react-i18next";
import { useRillContext } from "../../../rill/RillReact/share/base";

function View(props) {
  const { t } = useTranslation("dashboard");
  const { locals } = useRillContext();

  const { snapshot, momentTZ } = locals;
  const activeExercises = _.get(snapshot, "data.activeExercises", {});
  const activeDay = momentTZ(
    _.get(_.first(activeExercises), "date", momentTZ())
  );

  return (
    <div className="body metrics">
      <h1 className="alt">{activeDay.format("dddd. MMMM D, YYYY")}</h1>
      <br />
      <div className="Workout">
        <div className="head">{t("shareWorkout.exercises")}</div>
        <div className="details">
          {_.map(activeExercises, (exercise, i) => {
            const primary = _.get(exercise, "primary");
            const defaultRepMax = locals.fromMetric(
              _.get(exercise, `repMaximums.${primary}`, 0)
            );
            const isAssistant = primary === "assistant";
            const equipped = !isAssistant && _.some(exercise.sets, "equipped");

            return (
              <div
                className={cx("Exercise", primary, { equipped })}
                key={exercise._id}
              >
                <div className="head">
                  {_.capitalize(primary)}{" "}
                  {exercise.secondary &&
                    `(${_.capitalize(exercise.secondary)})`}
                </div>

                <div className="details">
                  <div className="details-col-1">
                    {_.map(exercise.sets, (it) => {
                      const equippedRepMax = locals.fromMetric(
                        it.equippedRepMax
                      );
                      const repMax = equippedRepMax || defaultRepMax;
                      const load = locals.fromMetric(it.load);
                      const percentRM = _.round((load / repMax) * 100, 1);
                      const isEquipped = !isAssistant && it.equipped;
                      const hasLoad = Boolean(load);
                      return (
                        <div className="routine">
                          <div>
                            <b>{t("shareWorkout.sets")}</b> {it.sets}
                          </div>
                          <div>
                            <b>{t("shareWorkout.reps")}</b> {it.reps}
                          </div>
                          {hasLoad && (
                            <div>
                              <b>{t("shareWorkout.load")}</b> {locals.withWeight(load)}
                            </div>
                          )}
                          {hasLoad && !isAssistant && (
                            <div>
                              <b>{t("shareWorkout.intensity")}</b> {percentRM}%
                            </div>
                          )}
                          {it.rpe > 0 && (
                            <div>
                              <b>{t("shareWorkout.rpe")}</b> {it.rpe}
                            </div>
                          )}

                          {isEquipped && (
                            <div>
                              <b>{t("shareWorkout.equipped")}</b> {it.equipment}
                            </div>
                          )}

                          {isEquipped && (
                            <div>
                              <b>{t("shareWorkout.equippedRm")}</b>{" "}
                              {locals.withWeight(equippedRepMax)}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                  <div className="details-col-2">
                    {exercise.notes && (
                      <div className="notes">
                        <b>{t("common:notes")}</b> {exercise.notes}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default View;
